export const unixToDateConversion = (unix) => {
  return new Date(unix * 1000).toLocaleDateString();
};
